<!-- eslint-disable max-len -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-dialog
      v-model="confirm_dialog"
      max-width="900"
    >
      <v-card>
        <v-card-title class="headline">
          Confirmación
        </v-card-title>
        <v-card-text>
          ¿Desea des asociar al residente de la vivienda?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="cancel_delete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="delete_asoc()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="add_dialog"
      max-width="900"
      :attach="this.$refs.viviendaSection"
      hide-overlay
    >
      <v-card>
        <v-card-title class="headline">
          Asociar Vivienda
        </v-card-title>
        <v-container grid-list-md>
          <v-form
            ref="viviendaForm"
            v-model="viviendaValid"
            lazy-validation
          >
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-combobox
                  v-model="vivienda_asoc"
                  :items="viviendas"
                  :loading="viviendaIsLoading"
                  :search-input.sync="viviendaSearch"
                  :hide-no-data="!viviendaSearch"
                  hide-selected
                  item-text="n_vivienda"
                  item-value="n_vivienda"
                  label="Vivienda"
                  placeholder="Comience a escribir para buscar"
                  return-object
                  :rules="text_required_rules"
                >
                </v-combobox>
              </v-flex>
            </v-layout>
            <v-spacer></v-spacer>
            <v-checkbox
              v-model="puedeAutorizar_asoc"
              label="Puede Autorizar"
              disabled
            ></v-checkbox>
            <v-radio-group v-model="tipoResidente_asoc" row :rules="text_required_rules">
              <v-radio label="Propietario" value="propietario"></v-radio>
              <v-radio label="Propietario Residente" value="propietario_residente"></v-radio>
              <v-radio label="Residente Inquilino" value="residente_inquilino"></v-radio>
            </v-radio-group>
            <v-layout wrap v-if="tipoResidente_asoc === 'residente_inquilino'">
              <FechaPicker v-model="fecha_inicio_arrendamiento" size='6' :birthday-picker=false
                           label="Fecha Inicio Arrendamiento" />
              <FechaPicker v-model="fecha_fin_arrendamiento" size='6' :birthday-picker=false
                           label="Fecha Fin Arrendamiento" />
            </v-layout>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="add_dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="send_resident_form"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="application_dialog"
      max-width="900"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Registro en Aplicación
        </v-card-title>
        <v-container grid-list-md>
          <v-alert
            :value="alertDialog"
            :type="alertDialogType"
            outline
          >
            {{ alertDialogMessage }}
          </v-alert>
          <v-form
            ref="applicationForm"
            v-model="applicationValid"
            v-if="this.resident_info.residente_id"
            lazy-validation
          >
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="usuario"
                  :rules="emailRules"
                  :type="'email'"
                  label="Correo Electrónico"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="password"
                  label="Contraseña"
                  autocomplete="on"
                  :rules="passwordRules"
                  :type="passwordFieldType"
                  :hint="hintPassword"
                  counter
                >
                  <template slot="append">
                    <v-icon v-if="passwordFieldType=='password'"
                            @click="switchVisibility" small>
                      visibility
                    </v-icon>
                    <v-icon v-else @click="switchVisibility" small>
                      visibility_off
                    </v-icon>
                  </template>
                  <template slot="append-outer">
                    <v-icon @click="generatePassword()" class="mr-3" small>
                      autorenew
                    </v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="rePassword"
                  label="Confirmar Contraseña"
                  autocomplete="on"
                  :rules="[passwordConfirmationRule]"
                  :type="passwordConfirmFieldType"
                  :hint="hintPassword"
                  counter
                >
                  <template slot="append">
                    <v-icon v-if="passwordConfirmFieldType=='password'"
                            @click="switchVisibilityConfirm" small>
                      visibility
                    </v-icon>
                    <v-icon v-else @click="switchVisibilityConfirm" small>
                      visibility_off
                    </v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-checkbox
                  v-model="send_email"
                  label="Enviar por correo electrónico usuario y contraseña"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-form>
          <div v-else class="text-xs-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat"
                 @click="close_application_dialog"
          >
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 @click="send_application_form"
                 v-if="this.resident_info.residente_id"
          >
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 v-else
                 disabled
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="edit_application_dialog"
      max-width="900"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Restablecer Contraseña
        </v-card-title>
        <v-container grid-list-md>
          <v-alert
            :value="alertDialog"
            :type="alertDialogType"
            outline
          >
            {{ alertDialogMessage }}
          </v-alert>
          <v-form
            ref="editApplicationForm"
            v-model="editApplicationValid"
            v-if="this.resident_info.residente_id"
            lazy-validation
          >
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="resident_info.usuario"
                  :type="'email'"
                  label="Correo Electrónico"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="password"
                  label="Contraseña"
                  autocomplete="on"
                  :rules="passwordRules"
                  :type="passwordFieldType"
                  :hint="hintPassword"
                  counter
                >
                  <template slot="append">
                    <v-icon v-if="passwordFieldType=='password'"
                            @click="switchVisibility" small>
                      visibility
                    </v-icon>
                    <v-icon v-else @click="switchVisibility" small>
                      visibility_off
                    </v-icon>
                  </template>
                  <template slot="append-outer">
                    <v-icon @click="generatePassword()" class="mr-3" small>
                      autorenew
                    </v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-text-field
                  v-model="rePassword"
                  label="Confirmar Contraseña"
                  autocomplete="on"
                  :rules="[passwordConfirmationRule]"
                  :type="passwordConfirmFieldType"
                  :hint="hintPassword"
                  counter
                >
                  <template slot="append">
                    <v-icon v-if="passwordConfirmFieldType=='password'"
                            @click="switchVisibilityConfirm" small>
                      visibility
                    </v-icon>
                    <v-icon v-else @click="switchVisibilityConfirm" small>
                      visibility_off
                    </v-icon>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-checkbox
                  v-model="send_email"
                  label="Enviar por correo electrónico usuario y contraseña"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-form>
          <div v-else class="text-xs-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat"
                 @click="close_application_dialog"
          >
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 @click="send_edit_application_form"
                 v-if="this.resident_info.residente_id"
          >
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 v-else
                 disabled
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirm_session_dialog"
      max-width="900"
    >
      <v-card>
        <v-card-title class="headline">
          Confirmación
        </v-card-title>
        <v-card-text v-if="this.resident_info.residente_id">
          ¿Está seguro que desea cerrar la sesión activa de <span class="font-weight-bold">{{
            `${this.resident_info.nombres} ${this.resident_info.apellido_paterno} ${this.resident_info.apellido_materno}`
          }}</span>?
        </v-card-text>
        <v-card-text v-else>
          <div class="text-xs-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat"
                 @click="confirm_session_dialog = false">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 @click="send_session_application_form"
                 v-if="this.resident_info.residente_id"
          >
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 v-else
                 disabled
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirm_deleted_dialog"
      max-width="900"
    >
      <v-card>
        <v-card-title class="headline">
          Confirmación
        </v-card-title>
        <v-card-text v-if="this.resident_info.residente_id">
          ¿Está seguro que desea eliminar al residente: <span class="font-weight-bold">{{
            `${this.resident_info.nombres} ${this.resident_info.apellido_paterno} ${this.resident_info.apellido_materno}`
          }}</span>?
        </v-card-text>
        <v-card-text v-else>
          <div class="text-xs-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat="flat"
                 @click="confirm_deleted_dialog = false">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 @click="delete_resident_confirm"
                 v-if="this.resident_info.residente_id"
          >
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat="flat"
                 v-else
                 disabled
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container grid-list-md fluid>
      <v-alert
        :value="alert"
        dismissible
        :type="alertType"
      >
        {{ alertMessage }}
      </v-alert>
      <v-layout wrap>
        <v-flex xs12 sm10 md11>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="presearch"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        </v-flex>
        <v-flex xs12 sm2 md1 class="pt-4">
          <v-btn color="primary" dark @click.prevent="openDialog()"
                 v-show="add_btn === true" :disabled="!add_btn">
            Agregar
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="residentes"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="is_loading"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr >
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">{{ props.item.nombres }}</td>
          <td class="text-xs-left">{{ props.item.apellido_paterno }}</td>
          <td class="text-xs-left">{{ props.item.apellido_materno }}</td>
          <td class="text-xs-left hidden-md-and-down">{{ props.item.nds }}</td>
          <td class="text-xs-left hidden-md-and-down">{{ props.item.status }}</td>
          <td class="text-xs-left">
            <template v-for="(vivienda, index) in props.item.viviendas">
              {{ vivienda.n_vivienda }}
              <template v-if="index + 1 < props.item.viviendas.length">,</template>
            </template>
          </td>
          <td class="text-xs-left hidden-md-and-down">
            <template v-for="(vivienda, index) in props.item.viviendas">
              {{ vivienda.tipo }}
              <template v-if="index + 1 < props.item.viviendas.length">,</template>
            </template>
          </td>
          <td v-if="props.item.censado" class="text-xs-left hidden-md-and-down">{{ props.item.censado_fecha }}</td>
          <td v-else class="text-xs-left"></td>
          <td class="text-xs-left hidden-md-and-down">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon @click="show_resident_info(props.item.id)"
                        v-show="view_btn === true" :disabled="!view_btn"
                        v-on="on" class="mr-3" small>
                  visibility
                </v-icon>
              </template>
              <span>Detalles del Residente</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon @click="edit_resident(props.item.id)"
                        v-show="edit_btn === true" :disabled="!edit_btn"
                        v-on="on" class="mr-3" small>
                  edit
                </v-icon>
              </template>
              <span>Editar Residente</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon @click="show_delete_resident_dialog(props.item.id)"
                        v-show="delete_btn === true" :disabled="!delete_btn"
                        v-on="on" class="mr-3" small>
                  delete
                </v-icon>
              </template>
              <span>Eliminar Residente</span>
            </v-tooltip>
            <span class="text-xs-center">
              <v-menu top offset-y>
                <template v-slot:activator="{ on }">
                  <v-icon v-show="app_btn === true" :disabled="!app_btn" v-on="on" small>
                    phonelink_setup
                  </v-icon>
                </template>
                <template>
                  <v-list>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span class="ml-2 mr-3">
                          <v-icon v-if="props.item.usuario" small disabled>
                            smartphone
                          </v-icon>
                          <v-icon v-else small
                                  v-on="on"
                                  @click="add_application_info(props.item.id)">
                            smartphone
                          </v-icon>
                        </span>
                      </template>
                      <span>Registro en Aplicación</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span class="mr-3">
                          <v-icon v-if="props.item.usuario" small
                                  v-on="on"
                                  @click="edit_application_info(props.item.id)">
                            phonelink_lock
                          </v-icon>
                          <v-icon v-else disabled small>
                            phonelink_lock
                          </v-icon>
                        </span>
                      </template>
                      <span>Restablecer Contraseña</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <span class="mr-2">
                          <v-icon v-if="props.item.jti" small
                                  v-on="on"
                                  @click="close_session_application_info(props.item.id)">
                            phonelink_erase
                          </v-icon>
                          <v-icon v-else disabled small>
                            phonelink_erase
                          </v-icon>
                        </span>
                      </template>
                      <span>Cerrar Sesión</span>
                    </v-tooltip>
                  </v-list>
                </template>
              </v-menu>
            </span>
          </td>
          <td class="text-xs-left hidden-lg-and-up">
            <v-flex xs12 sm2 md1 class="text-md-right">
              <v-btn slot="activator" color="primary" dark class="mb-2"
                     @click="show_resident_info(props.item.id)" v-show="view_btn === true" :disabled="!view_btn">VER
              </v-btn>
            </v-flex>
            <v-flex xs12 sm2 md1 class="text-md-right">
              <v-btn slot="activator" color="primary" dark class="mb-2"
                     @click="edit_resident(props.item.id)" v-show="edit_btn === true" :disabled="!edit_btn">EDITAR
              </v-btn>
            </v-flex>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-container grid-list-md>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close_dialog">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title><span class="headline">{{ formTitle }}</span></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="send_form">Guardar</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container grid-list-md fluid>
            <v-alert
              :value="alertDialog"
              :type="alertDialogType"
              outline
            >
              {{ alertDialogMessage }}
            </v-alert>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-form
                  ref="form"
                  id="resident_form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-layout row wrap>
                    <v-flex xs12 sm3 md3>
                      <v-text-field
                        v-model="nombres_residente"
                        label="Nombre(s)"
                        required
                      />
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-text-field
                        v-model="apellido_paterno_residente"
                        label="Apellido Paterno"
                        required
                      />
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-text-field
                        v-model="apellido_materno_residente"
                        label="Apellido Materno"
                        required
                      />
                    </v-flex>
                    <v-flex xs12 sm1 md1>
                      <v-text-field
                        v-model="residente_nds"
                        label="NDS"
                        required
                      />
                    </v-flex>
                    <v-flex xs12 sm2 md2>
                      <v-text-field
                        v-model="residente_dependiente_de"
                        label="Dependiente de"
                      />
                    </v-flex>
                    <v-flex xs12 sm1 md1>
                      <v-switch v-model="accion_switch" label="Tiene acción:"/>
                    </v-flex>
                    <v-flex xs12 sm2 md2>
                      <v-text-field
                        :disabled="disable_action_number_field"
                        v-model="residente_accion_number"
                        label="# de acción"
                      />
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-select
                        v-model="status_residente"
                        :items="tipos_status"
                        label="Estatus Socio"
                        required
                      />
                    </v-flex>
                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-model="direccion_residente"
                        label="Dirección"
                        required
                      />
                    </v-flex>
                    <v-flex xs12 sm2 md2>
                      <v-text-field
                        v-model="codigo_postal"
                        label="Código Postal"
                        required
                      />
                    </v-flex>
                    <v-flex xs12 sm2 md2>
                      <v-select
                        v-model="estado_civil"
                        :items="tipos_status_civil"
                        label="Estado Civil"
                        required
                      />
                    </v-flex>
                    <v-flex xs12 sm2 md2>
                      <v-select
                        v-model="sexo"
                        :items="tipo_sexo"
                        label="Sexo"
                        required
                      />
                    </v-flex>
                    <FechaPicker v-model="fecha_nacimiento" label="Fecha Nacimiento" />
                    <FechaPicker v-model="fecha_ingreso" label="Fecha Ingreso" />
                     <v-flex xs12 sm3 md3>
                      <v-text-field
                        v-model="ine_residente"
                        label="INE"
                      />
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-text-field
                        v-model="curp_residente"
                        label="CURP"
                      />
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-select
                        v-model="escuela_residente"
                        :items="opciones_escuela"
                        label="Estudia En"
                        required
                      />
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-text-field
                        v-model="notas_residente"
                        label="Notas"
                      />
                    </v-flex>
                    <v-layout row wrap>
                      <v-flex xs12 sm10 md10 class="text-md-left">
                        <strong>En Caso de Emergencia Avisar A</strong>
                        <v-divider/>
                      </v-flex>
                      <v-flex xs12 sm2 md1 class="text-md-right">
                        <v-btn slot="activator" color="primary" dark class="mb-2"
                               @click="append_contacto_emergencia">Agregar
                        </v-btn>
                      </v-flex>
                      <v-layout row wrap>
                        <v-flex xs12 sm4 md4>
                          <v-text-field
                            v-model="nombre_emergencia"
                            label="Nombre Completo"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm4 md4>
                          <v-text-field
                            v-model="email_emergencia"
                            label="Correo Electrónico"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm3 md3>
                          <v-text-field
                            v-model="telefono_emergencia"
                            label="Teléfono"
                            required
                          />
                        </v-flex>
                        <v-flex xs12 sm12 md12 class="text-md-left">
                          <template v-for="(contacto_emergencia, index) in contactos_emergencia">
                            <v-layout row wrap v-bind:key="contacto_emergencia.id">
                              <v-flex xs12 sm4 md4>
                                <v-text-field
                                  v-model="contacto_emergencia.nombre_emergencia"
                                  label="Nombre Completo"
                                  required
                                />
                              </v-flex>
                              <v-flex xs12 sm4 md4>
                                <v-text-field
                                  v-model="contacto_emergencia.email_emergencia"
                                  label="Correo Electrónico"
                                  required
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm3 md3>
                                <v-text-field
                                  v-model="contacto_emergencia.telefono_emergencia"
                                  label="Teléfono"
                                  required
                                />
                              </v-flex>
                              <v-flex xs12 sm1 md1 class="text-md-left">
                                <v-btn slot="activator" color="primary" dark class="mb-2"
                                       @click="delete_contacto_emergencia(index)">Eliminar
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </template>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md12 class="text-md-left">
                        <strong>Zonas de Interés y Comunicados</strong>
                        <v-divider/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="interes_golf" label="Golf"/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="interes_tenis" label="Tenis & Padel"/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="interes_natacion" label="Natación"/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="interes_gym" label="Gimnasio"/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="interes_ludoteca" label="Ludoteca"/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="interes_ayb" label="Alimentos & Bebidas"/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="interes_torneos" label="Torneos"/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="interes_eventos" label="Eventos Sociales & Culturales"/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="interes_comunicados" label="Comunicados De Interés"/>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md12 class="text-md-left">
                        <strong>Como Desea Recibir la Información</strong>
                        <v-divider/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="medio_grupo_whatsapp" label="Grupos de WhatsApp"/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="medio_chat_privado" label="WhatsApp privado"/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="medio_email" label="Correo Electrónico"/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="medio_telefono" label="Teléfono"/>
                      </v-flex>
                      <v-flex xs12 sm2 md2>
                        <v-checkbox v-model="medio_app" label="Directo en la app"/>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm10 md10 class="text-md-left">
                      <strong>Correos Electrónicos</strong>
                      <v-divider/>
                    </v-flex>
                    <v-flex xs12 sm2 md1 class="text-md-right">
                      <v-btn slot="activator" color="primary" dark class="mb-2"
                             @click="append_email">Agregar
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12 class="text-md-left">
                      <template v-for="(email, index) in emails">
                        <v-layout row wrap v-bind:key="email.id">
                          <v-flex xs12 sm4 md4>
                            <v-text-field
                              label="Correo Electrónico"
                              placeholder=""
                              v-model="email.email"
                              counter
                            />
                          </v-flex>
                          <v-flex xs12 sm4 md4>
                            <v-select
                              v-model="email.tipo"
                              :items="tipos_email"
                              label="Tipo"
                              required
                            />
                          </v-flex>
                          <v-flex xs12 sm1 md1 class="text-md-left">
                            <v-btn slot="activator" color="primary" dark class="mb-2"
                                   @click="delete_email(index)">Eliminar
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </template>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm10 md10 class="text-md-left">
                      <strong>Teléfonos</strong>
                      <v-divider/>
                    </v-flex>
                    <v-flex xs12 sm2 md1 class="text-md-right">
                      <v-btn slot="activator" color="primary" dark class="mb-2"
                             @click="append_phone">Agregar
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12 class="text-md-left">
                      <template v-for="(telefono, index) in telefonos">
                        <v-layout row wrap v-bind:key="telefono.id">
                          <v-flex xs12 sm4 md4>
                            <v-text-field
                              label="Teléfono"
                              placeholder=""
                              :rules="text_required_rules"
                              v-model="telefono.telefono"
                              maxlength="11"
                              counter
                            />
                          </v-flex>
                          <v-flex xs12 sm2 md2>
                            <v-select
                              v-model="telefono.tipo"
                              :items="tipos"
                              :rules="text_required_rules"
                              label="Tipo"
                              required
                            />
                          </v-flex>
                          <v-flex xs12 sm4 md4>
                            <v-text-field
                              label="Nombre Completo"
                              placeholder=""
                              v-model="telefono.nombre"
                              counter
                            />
                          </v-flex>
                          <v-flex xs12 sm1 md1 class="text-md-left">
                            <v-btn slot="activator" color="primary" dark class="mb-2"
                                   @click="delete_phone(index)">Eliminar
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </template>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap ref="viviendaSection">
                    <v-flex xs12 sm10 md10 class="text-md-left">
                      <strong>Viviendas</strong>
                      <v-divider/>
                    </v-flex>
                    <v-flex xs12 sm2 md1 class="text-md-right">
                      <v-btn slot="activator" color="primary" dark class="mb-2"
                             @click="append_vivienda">Agregar
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12 class="text-md-left">
                      <template v-for="(vivienda, index) in viviendasAsociadas">
                        <v-layout row wrap v-bind:key="vivienda.id">
                          <v-flex xs12 sm3 md2>
                            <v-text-field
                              label="Vivienda"
                              placeholder=""
                              :rules="text_required_rules"
                              v-model="vivienda.n_vivienda"
                              readonly
                            />
                          </v-flex>
                          <v-flex xs12 sm2 md2>
                            <v-checkbox v-model="vivienda.puede_autorizar" label="Puede Autorizar" readonly/>
                          </v-flex>
                          <v-flex xs12 sm2 md2>
                            <v-checkbox v-model="vivienda.propietario" label="Propietario" readonly/>
                          </v-flex>
                          <v-flex xs12 sm2 md2>
                            <v-checkbox v-model="vivienda.propietario_residente" label="Propietario Residente"
                                        readonly/>
                          </v-flex>
                          <v-flex xs12 sm2 md2>
                            <v-checkbox v-model="vivienda.residente_inquilino" label="Residente Inquilino" readonly/>
                          </v-flex>
                          <v-flex xs12 sm1 md1 class="text-md-left">
                            <v-btn slot="activator" color="primary" dark class="mb-2"
                                   @click="delete_vivienda(index)">Eliminar
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </template>
                    </v-flex>
                  </v-layout>
                  <camera v-model="fotos"></camera>
                  <!--
                  <strong class="hidden-md-and-down">Firma - Aviso de Privacidad</strong>
                  <v-divider class="hidden-md-and-down"/>
                  <embed class="hidden-md-and-down" src="files/privacidad.pdf" type="application/pdf" width="100%"
                         height="600px"/>
                  <signature v-model="firmas"></signature>
                  <strong class="hidden-md-and-down">Huella</strong>
                  <v-divider class="hidden-md-and-down"/>
                  <biomini v-model="fingerPrint"></biomini>
                  -->
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
    <v-container grid-list-md>
      <v-dialog v-model="infodialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close_info_dialog">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Detalles del Residente</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container grid-list-md fluid>
            <v-layout row wrap class="pb-4">
              <template>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    label="Nombre(s)"
                    placeholder=""
                    readonly
                    v-model="resident_info.nombres"
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    label="Apellido Paterno"
                    placeholder=""
                    readonly
                    v-model="resident_info.apellido_paterno"
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    label="Apellido Materno"
                    placeholder=""
                    readonly
                    v-model="resident_info.apellido_materno"
                  />
                </v-flex>
                <v-flex xs12 sm1 md1>
                  <v-text-field
                    v-model="resident_info.nds"
                    label="NDS"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field
                    v-model="resident_info.dependiente_de"
                    label="Dependiente de"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm1 md2>
                  <v-switch readonly v-model="resident_info.tiene_accion" label="Tiene acción:">
                  </v-switch>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field
                    readonly=""
                    v-model="resident_info.n_accion"
                    label="# de acción"
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    readonly
                    v-model="resident_info.status"
                    label="Estatus Socio"
                  />
                </v-flex>
                <v-flex xs12 sm6 md5>
                  <v-text-field
                    v-model="resident_info.direccion"
                    label="Dirección"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field
                    v-model="resident_info.codigo_postal"
                    label="Código Postal"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-text-field
                    v-model="resident_info.estado_civil"
                    label="Estado Civil"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-select
                    v-model="resident_info.sexo"
                    label="Sexo"
                    :items="tipo_sexo"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3 v-if="resident_info.fecha_nacimiento === 'None'">
                  <v-text-field
                    label="Fecha Nacimiento"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3 v-else>
                  <v-text-field
                    v-model="resident_info.fecha_nacimiento"
                    label="Fecha Nacimiento"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3 v-if="resident_info.fecha_ingreso === 'None'">
                  <v-text-field
                    label="Fecha Ingreso"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3 v-else>
                  <v-text-field
                    v-model="resident_info.fecha_ingreso"
                    label="Fecha Ingreso"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                      <v-text-field
                        v-model="resident_info.ine"
                        label="INE"
                        readonly
                      />
                    </v-flex>
                    <v-flex xs12 sm3 md3>
                      <v-text-field
                        v-model="resident_info.curp"
                        label="CURP"
                        readonly
                      />
                    </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="resident_info.estudia_en"
                    label="Estudia En"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="resident_info.notas"
                    label="Notas"
                    readonly
                  />
                </v-flex>
              </template>
              <template>
                <v-flex xs12 sm12 md12 class="text-md-left">
                  <strong>En Caso de Emergencia Avisar A</strong>
                  <v-divider/>
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="resident_info.nombre_contacto_emergencia"
                    label="Nombre Completo"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="resident_info.email_contacto_emergencia"
                    label="Correo Electrónico"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm4 md4>
                  <v-text-field
                    v-model="resident_info.telefono_contacto_emergencia"
                    label="Teléfono"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-data-table
                    :headers="contactos_emergencia_headers"
                    v-bind:items="resident_info.contactos_emergencia"
                  >
                    <template v-slot:items="props">
                      <tr>
                        <td class="text-xs-left">{{ props.item.nombre_emergencia }}</td>
                        <td class="text-xs-left">{{ props.item.email_emergencia }}</td>
                        <td class="text-xs-left">{{ props.item.telefono_emergencia }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </template>
              <template>
                <v-flex xs12 sm12 md12 class="text-md-left">
                  <strong>Zonas de Interés y Comunicados</strong>
                  <v-divider/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.interes_golf" label="Golf" readonly/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.interes_tenis" label="Tenis & Padel" readonly/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.interes_natacion" label="Natación" readonly/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.interes_gym" label="Gimnasio" readonly/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.interes_ludoteca" label="Ludoteca" readonly/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.interes_ayb" label="Alimentos & Bebidas" readonly/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.interes_torneos" label="Torneos" readonly/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.interes_eventos" label="Eventos Sociales & Culturales" readonly/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.interes_comunicados" label="Comunicados De Interés" readonly/>
                </v-flex>
              </template>
              <template>
                <v-flex xs12 sm12 md12 class="text-md-left">
                  <strong>Como Desea Recibir la Información</strong>
                  <v-divider/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.medio_gpo_whatsapp" label="Grupos de WhatsApp" readonly/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.medio_chat_whatsapp" label="WhatsApp privado" readonly/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.medio_email" label="Correo Electrónico" readonly/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.medio_telefono" label="Teléfono" readonly/>
                </v-flex>
                <v-flex xs12 sm2 md2>
                  <v-checkbox v-model="resident_info.medio_app" label="Directo en la app" readonly/>
                </v-flex>
              </template>
            </v-layout>
            <template>
              <v-flex xs12 sm12 md12>
                <strong>Correos Electrónicos</strong>
                <v-divider/>
              </v-flex>
              <v-data-table
                :headers="email_headers"
                :items="resident_info.emails"
              >
                <template v-slot:items="props">
                  <tr>
                    <td class="text-xs-left">{{ props.item.email }}</td>
                    <td class="text-xs-left">{{ props.item.tipo }}</td>
                  </tr>
                </template>
              </v-data-table>
            </template>
            <template>
              <v-flex xs12 sm12 md12>
                <strong>Teléfonos</strong>
                <v-divider/>
              </v-flex>
              <v-data-table
                :headers="telefonos_headers"
                :items="resident_info.telefonos"
              >
                <template v-slot:items="props">
                  <tr>
                    <td class="text-xs-left">{{ props.item.telefono }}</td>
                    <td class="text-xs-left">{{ props.item.tipo }}</td>
                    <td class="text-xs-left">{{ props.item.nombre }}</td>
                  </tr>
                </template>
              </v-data-table>
            </template>
            <template>
              <v-flex xs12 sm12 md12>
                <strong>Viviendas</strong>
                <v-divider/>
              </v-flex>
              <v-data-table
                :headers="viviendas_headers"
                :items="resident_info.viviendas"
              >
                <template v-slot:items="props">
                  <tr>
                    <td class="text-xs-left">{{ props.item.vivienda.desarrollo }}</td>
                    <td class="text-xs-left">{{ props.item.vivienda.subcondominio }}</td>
                    <td class="text-xs-left">{{ props.item.vivienda.n_vivienda }}</td>
                    <td class="text-xs-left">{{ props.item.vivienda.telefono }}</td>
                    <td class="text-xs-left">{{ props.item.vivienda.status }}</td>
                    <td v-if="props.item.puede_autorizar" class="text-xs-left">SI</td>
                    <td v-else class="text-xs-left">NO</td>
                    <td v-if="props.item.propietario" class="text-xs-left">SI</td>
                    <td v-else class="text-xs-left">NO</td>
                    <td v-if="props.item.propietario_residente" class="text-xs-left">SI</td>
                    <td v-else class="text-xs-left">NO</td>
                    <td v-if="props.item.residente_inquilino" class="text-xs-left">SI</td>
                    <td v-else class="text-xs-left">NO</td>
                    <td v-if="props.item.residente_inquilino && props.item.inicio_arrendamiento !== null" class="text-xs-left">
                      {{ moment(props.item.inicio_arrendamiento).format('DD-MM-YYYY') }}
                      -
                      {{ moment(props.item.fin_arrendamiento).format('DD-MM-YYYY') }}
                    </td>
                    <td v-else class="text-xs-left">-</td>
                  </tr>
                </template>
              </v-data-table>
            </template>
            <template v-if="resident_info.rostros && resident_info.rostros.length > 0">
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <strong>Multimedia</strong>
                  <v-divider/>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <img style="width: 100%" alt="foto_rostro"
                       :src="decode_base64(resident_info.rostros[resident_info.rostros.length - 1].image)"
                  />
                </v-flex>
              </v-layout>
            </template>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import Camera from '@/components/camera.vue';
import FechaPicker from '@/components/fecha_picker.vue';
// import Signature from '@/components/signature.vue';
// import Biomini from '@/components/biomini.vue';
import { getJWTData } from '../common/jwt.service';
import moment from '../../node_modules/moment';
// eslint-disable-next-line import/no-cycle
import ApiService from '../common/api.service';

export default {
  components: {
    Camera,
    FechaPicker,
    // Signature,
    // Biomini,
  },
  data: () => ({
    totalItems: 0,
    residentes: [],
    pagination: {},
    notas_residente: null,
    timer: '',
    search: null,
    presearch: null,
    searchTimer: null,
    infodialog: false,
    fecha_nacimiento: '',
    fecha_ingreso: '',
    fecha_inicio_arrendamiento: '',
    fecha_fin_arrendamiento: '',
    direccion_residente: '',
    residente_nds: '',
    accion_switch: false,
    residente_accion_number: '',
    escuela_residente: '',
    estado_civil: '',
    sexo: '',
    interes_golf: false,
    interes_tenis: false,
    interes_natacion: false,
    interes_gym: false,
    interes_ludoteca: false,
    interes_ayb: false,
    interes_torneos: false,
    interes_eventos: false,
    interes_comunicados: false,
    medio_grupo_whatsapp: false,
    medio_email: false,
    medio_telefono: false,
    medio_redes_sociales: false,
    medio_chat_privado: false,
    medio_app: false,
    nombre_emergencia: '',
    email_emergencia: '',
    ine_residente: '',
    curp_residente: '',
    confirm_dialog: false,
    add_dialog: false,
    contactos_emergencia: [],
    vivienda_asoc: null,
    puedeAutorizar_asoc: false,
    tipoResidente_asoc: null,
    viviendaIsLoading: false,
    viviendaSearch: null,
    viviendasApiResult: [],
    viviendasAsociadas: [],
    viviendaValid: false,
    telefono_emergencia: '',
    opciones_escuela: ['COLEGIO MADISON', 'UNIVERSIDAD DEL MAYAB', 'OTRO COLEGIO', 'NINGUNO'],
    headers: [
      {
        text: 'id', value: 'id', sortable: false,
      },
      {
        text: 'Nombre(s)', value: 'nombres', sortable: false,
      },
      {
        text: 'Apellido Paterno', value: 'apellido_paterno', sortable: false,
      },
      {
        text: 'Apellido Materno', value: 'apellido_materno', sortable: false,
      },
      {
        text: 'NDS', value: 'nds', sortable: false, class: 'hidden-md-and-down',
      },
      {
        text: 'Estatus Socio', value: 'status', sortable: false, class: 'hidden-md-and-down',
      },
      {
        text: 'Vivienda', value: 'viviendas_residente', sortable: false,
      },
      {
        text: 'Tipo de Residente', value: 'viviendas_tipo_residente', sortable: false, class: 'hidden-md-and-down',
      },
      {
        text: 'Censado', value: 'censado_fecha', sortable: false, class: 'hidden-md-and-down',
      },
      {
        text: 'Acciones', value: 'acciones', sortable: false,
      },
    ],
    telefonos_headers: [
      {
        text: 'Teléfono', value: 'telefono', sortable: true,
      },
      {
        text: 'Tipo', value: 'tipo', sortable: true,
      },
      {
        text: 'Nombre Completo', value: 'nombre', sortable: true,
      },
    ],
    email_headers: [
      {
        text: 'Correo Electrónico', value: 'email', sortable: true,
      },
      {
        text: 'Tipo', value: 'tipo', sortable: true,
      },
    ],
    viviendas_headers: [
      {
        text: 'Condominio', value: 'vivienda.desarrollo', sortable: true,
      },
      {
        text: 'Subcondominio', value: 'vivienda.subcondominio', sortable: true,
      },
      {
        text: 'Vivienda', value: 'vivienda.n_vivienda', sortable: true,
      },
      {
        text: 'Teléfono', value: 'vivienda.telefono', sortable: true,
      },
      {
        text: 'Estatus', value: 'vivienda.status', sortable: true,
      },
      {
        text: 'Puede Autorizar', value: 'puede_autorizar', sortable: true,
      },
      {
        text: 'Propietario', value: 'propietario', sortable: true,
      },
      {
        text: 'Propietario Residente', value: 'propietario_residente', sortable: true,
      },
      {
        text: 'Residente Inquilino', value: 'residente_inquilino', sortable: true,
      },
      {
        text: 'Periodo Arrendamiento', value: 'periodo_arrendamiento', sortable: true,
      },
    ],
    contactos_emergencia_headers: [
      {
        text: 'Nombre Completo', value: 'nombre_emergencia', sortable: true,
      },
      {
        text: 'Correo Electrónico', value: 'email_emergencia', sortable: true,
      },
      {
        text: 'Teléfono', value: 'telefono_emergencia', sortable: true,
      },
    ],
    valid: true,
    status_residente: '',
    tipos_status: ['ACTIVO', 'INACTIVO', 'BLOQUEADO', 'SUSPENDIDO', 'FORÁNEO'],
    tipos_status_civil: ['CASAD@', 'SOLTER@', 'DIVORCIAD@', 'UNIÓN LIBRE', 'VIUD@'],
    tipo_sexo: [
      { text: 'Masculino', value: 'M' },
      { text: 'Femenino', value: 'F' },
    ],
    dialog: false,
    tipos: ['CASA', 'CELULAR', 'OFICINA', 'ASISTENTE', 'DOMÉSTIC@'],
    tipos_email: ['PRINCIPAL', 'NEGOCIO', 'OTRO'],
    email_residente: '',
    nombres_residente: '',
    apellido_paterno_residente: '',
    apellido_materno_residente: '',
    telefonos: [],
    emails: [],
    codigo_postal: '',
    residente_dependiente_de: '',
    disable_action_number_field: true,
    editing: false,
    hintPassword: 'La contraseña debe ser mínimo de 8 caracteres y contener al menos una mayúscula, una minúscula, un número y un carácter de puntuación. <br>Caracteres de puntuación aceptados: \'¡+,.-!"$%&/=?¿^*;:_|@#<>~\\',
    text_required_rules: [
      v => !!v || 'Requerido',
    ],
    max_11_rule: [
      v => (v && v.length <= 20) || '\'Debe ser menos de  12 caracteres',
    ],
    nameRules: [
      v => !!v || 'Nombre es requerido',
    ],
    apellidoRules: [
      v => !!v || 'Apellido es requerido',
    ],
    emailRules: [
      v => !!v || 'Correo electrónico requerido',
      v => /.+@.+/.test(v) || 'Correo electrónico no válido',
    ],
    passwordRules: [
      v => !!v || 'Requerido',
      v => /^(?=.*[a-zA-Z0-9¡+,.\-!"$%&/=?¿^*;:_|@#<>~'\\])(?=.{8,})+/.test(v)
        || 'La contraseña debe ser mínimo de 8 caracteres y contener al menos una mayúscula, una minúscula, un número y un carácter de puntuación. <br>Caracteres de puntuación aceptados: \'¡+,.-!"$%&/=?¿^*;:_|@#<>~\\',
    ],
    fotos: [],
    firmas: [],
    fingerPrint: {
      fingerprint_image: '',
      fingerprint_template: '',
    },
    processing: false,
    baseImg: 'data:image/png;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==',
    constraints: { video: { width: 1280, height: 720 } },
    application_dialog: false,
    applicationValid: false,
    usuario: '',
    password: '',
    rePassword: '',
    send_email: false,
    edit_application_dialog: false,
    editApplicationValid: false,
    disabledApp: true,
    disabledPwd: true,
    confirm_session_dialog: false,
    confirm_deleted_dialog: false,
    // alertDialogApp: true,
    passwordFieldType: 'password',
    passwordConfirmFieldType: 'password',
    view_btn: false,
    edit_btn: false,
    app_btn: false,
    delete_btn: false,
    add_btn: false,
  }),
  computed: {
    formTitle() {
      return this.editing === false ? 'Agregar Residente' : 'Editar Residente';
    },
    alertType() {
      return this.$store.getters['capturaResidentes/alertContainerType'];
    },
    alertMessage() {
      return this.$store.getters['capturaResidentes/alertContainerMessage'];
    },
    alert() {
      return this.$store.getters['capturaResidentes/alertContainer'];
    },
    viviendas() {
      return this.viviendasApiResult;
    },
    is_loading() {
      return this.$store.getters['capturaResidentes/is_loading'];
    },
    residente_aplicacion_submited() {
      return this.$store.getters['capturaResidentes/residente_aplicacion_submited'];
    },
    residente_submited() {
      return this.$store.getters['capturaResidentes/residente_submited'];
    },
    resident_info() {
      return this.$store.getters['capturaResidentes/resident_info'];
    },
    alertDialogType() {
      return this.$store.getters['capturaResidentes/alertDialogType'];
    },
    alertDialogMessage() {
      return this.$store.getters['capturaResidentes/alertDialogMessage'];
    },
    alertDialog() {
      return this.$store.getters['capturaResidentes/alertDialog'];
    },
    alertDialogApp() {
      return this.$store.getters['capturaResidentes/alertDialogApp'];
    },
    residente_processing() {
      return this.$store.getters['capturaResidentes/residente_processing'];
    },
    passwordConfirmationRule() {
      return () => (this.password === this.rePassword) || 'Las contraseñas deben ser identicas';
    },
  },
  watch: {
    pagination: {
      handler() {
        if (this.search !== '' && this.search != null) {
          this.getDataFromApi()
            .then((data) => {
              this.residentes = data.residentes;
              this.totalItems = data.total;
            });
        }
      },
      deep: true,
    },
    search(val) {
      if (val === '') {
        this.residentes = [];
        this.totalItems = 0;
      } else {
        this.getDataFromApi()
          .then((data) => {
            this.residentes = data.residentes;
            this.totalItems = data.total;
          });
      }
    },
    residente_processing(val) {
      this.processing = val;
    },
    resident_info(val) {
      if (this.editing) {
        if (typeof val.residente_id !== 'undefined') {
          this.init_edit_data(val);
        }
      } else if (this.application_dialog) {
        if (typeof val.residente_id !== 'undefined') {
          this.init_registration_application(val);
        }
      }
    },
    tipoResidente_asoc(val) {
      if (val === 'propietario') {
        this.puedeAutorizar_asoc = false;
      } else {
        this.puedeAutorizar_asoc = true;
      }
    },
    accion_switch(val) {
      if (val) {
        this.disable_action_number_field = false;
      } else {
        this.disable_action_number_field = true;
      }
    },
    residente_submited(val) {
      if (val) {
        this.$refs.form.reset();
        this.close_dialog();
      }
    },
    viviendaSearch() {
      // Items have already been loaded
      if (this.viviendas.length > 0) return;
      // Items have already been requested
      if (this.viviendaIsLoading) return;
      this.viviendaIsLoading = true;
      ApiService.setHeader();
      ApiService.query('accesos/viviendas')
        .then(({ data }) => {
          this.viviendasApiResult = data.viviendas;
        })
        .catch(({ response }) => {
          console.log(response);
        })
        .finally(() => {
          this.viviendaIsLoading = false;
        });
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
    menu_fecha_nacimiento(value) {
      // eslint-disable-next-line no-unused-expressions,no-return-assign
      value && this.$nextTick(() => this.$refs.picker.activePicker = 'YEAR');
    },
    menu_fecha_ingreso(value) {
      // eslint-disable-next-line no-unused-expressions,no-return-assign
      value && this.$nextTick(() => this.$refs.picker_ingreso.activePicker = 'YEAR');
    },
    residente_aplicacion_submited(val) {
      if (val) {
        this.$refs.applicationForm.reset();
        this.$refs.editApplicationForm.reset();
        this.close_application_dialog();
      }
    },
  },
  methods: {
    moment,
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;

        const formdata = {
          page,
          per_page: rowsPerPage,
          search: this.search,
          order_by: sortBy,
          descending,
        };
        this.$store.dispatch('capturaResidentes/fetchResidentes', formdata)
          .then((data) => {
            this.loading = false;
            const { residentes, total } = data;
            this.$store.commit('capturaResidentes/fetchedResidentes');
            resolve({
              residentes,
              total,
            });
          });
      });
    },
    init_edit_data(data) {
      this.telefonos = [...data.telefonos];
      this.nombres_residente = data.nombres;
      this.apellido_paterno_residente = data.apellido_paterno;
      this.apellido_materno_residente = data.apellido_materno;
      this.emails = [...data.emails];
      this.contactos_emergencia = [...data.contactos_emergencia];
      this.status_residente = data.status;
      this.viviendasAsociadas = [...data.viviendas];
      this.notas_residente = data.notas;
      this.residente_nds = data.nds;
      this.residente_dependiente_de = data.dependiente_de;
      this.accion_switch = data.tiene_accion;
      this.residente_accion_number = data.n_accion;
      this.direccion_residente = data.direccion;
      this.codigo_postal = data.codigo_postal;
      this.estado_civil = data.estado_civil;
      this.sexo = data.sexo;
      if (data.fecha_nacimiento === 'None') {
        this.fecha_nacimiento = '';
      } else {
        this.fecha_nacimiento = data.fecha_nacimiento;
      }
      if (data.fecha_ingreso === 'None') {
        this.fecha_ingreso = '';
      } else {
        this.fecha_ingreso = data.fecha_ingreso;
      }
      this.escuela_residente = data.estudia_en;
      this.nombre_emergencia = data.nombre_contacto_emergencia;
      this.email_emergencia = data.email_contacto_emergencia;
      this.telefono_emergencia = data.telefono_contacto_emergencia;
      this.interes_golf = data.interes_golf;
      this.interes_tenis = data.interes_tenis;
      this.interes_natacion = data.interes_natacion;
      this.interes_gym = data.interes_gym;
      this.interes_ludoteca = data.interes_ludoteca;
      this.interes_ayb = data.interes_ayb;
      this.interes_torneos = data.interes_torneos;
      this.interes_eventos = data.interes_eventos;
      this.interes_comunicados = data.interes_comunicados;
      this.medio_grupo_whatsapp = data.medio_gpo_whatsapp;
      this.medio_chat_privado = data.medio_chat_whatsapp;
      this.medio_email = data.medio_email;
      this.medio_telefono = data.medio_telefono;
      this.medio_app = data.medio_app;
      this.curp_residente = data.curp;
      this.ine_residente = data.ine;
    },
    init_registration_application(data) {
      const tmpemails = [...data.emails];
      let i;
      for (i = 0; i < tmpemails.length; i++) {
        if (tmpemails[i].tipo === 'PRINCIPAL') {
          this.usuario = tmpemails[i].email;
          break;
        } else if (i === 0) {
          this.usuario = tmpemails[i].email;
        }
      }
      // this.alertDialogApp = false;
    },
    append_vivienda() {
      this.add_dialog = true;
    },
    send_resident_form() {
      if (this.$refs.viviendaForm.validate()) {
        let propietario = false;
        let residente = false;
        let inquilino = false;
        if (this.tipoResidente_asoc === 'propietario') {
          residente = false;
          inquilino = false;
          propietario = true;
        }
        if (this.tipoResidente_asoc === 'propietario_residente') {
          residente = true;
          inquilino = false;
          propietario = false;
        }
        if (this.tipoResidente_asoc === 'residente_inquilino') {
          residente = false;
          inquilino = true;
          propietario = false;
        }
        const formdata = {
          vivienda_id: this.vivienda_asoc.id,
          puede_autorizar: this.puedeAutorizar_asoc,
          propietario,
          propietario_residente: residente,
          residente_inquilino: inquilino,
          n_vivienda: this.vivienda_asoc.n_vivienda,
          inicio_arrendamiento: this.fecha_inicio_arrendamiento,
          fin_arrendamiento: this.fecha_fin_arrendamiento,
        };
        this.viviendasAsociadas.push(formdata);
        this.tipoResidente_asoc = null;
        this.vivienda_asoc = null;
        this.add_dialog = false;
        this.fecha_inicio_arrendamiento = null;
        this.fecha_fin_arrendamiento = null;
      }
    },
    close_application_dialog() {
      this.usuario = '';
      this.password = '';
      this.rePassword = '';
      this.send_email = false;
      this.application_dialog = false;
      this.edit_application_dialog = false;
      this.passwordFieldType = 'password';
      this.passwordConfirmFieldType = 'password';
      // this.alertDialogApp = true;
      this.$store.commit('capturaResidentes/clearAlertDialog');
      this.$store.commit('capturaResidentes/clearAlertDialogApp');
      this.$store.commit('capturaResidentes/resetSubmitedResidenteApplication');
    },
    add_application_info(resident) {
      this.$store.dispatch('capturaResidentes/fetchResidentInfo', resident);
      this.generatePassword();
      this.application_dialog = true;
    },
    edit_application_info(resident) {
      this.$store.dispatch('capturaResidentes/fetchResidentInfo', resident);
      this.edit_application_dialog = true;
    },
    close_session_application_info(resident) {
      this.$store.dispatch('capturaResidentes/fetchResidentInfo', resident);
      this.confirm_session_dialog = true;
    },
    show_resident_info(resident) {
      // console.log(resident);
      this.$store.dispatch('capturaResidentes/fetchResidentInfo', resident);
      this.infodialog = true;
    },
    edit_resident(resident) {
      // console.log(resident);
      this.editing = true;
      this.$store.dispatch('capturaResidentes/fetchResidentInfo', resident);
      this.dialog = true;
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    close_dialog() {
      this.editing = false;
      this.dialog = false;
      this.telefonos = [];
      this.nombres_residente = '';
      this.apellido_paterno_residente = '';
      this.apellido_materno_residente = '';
      this.emails = [];
      this.status_residente = '';
      this.ine_residente = '';
      this.curp_residente = '';
      this.viviendasAsociadas = [];
      this.contactos_emergencia = [];
      this.notas_residente = '';
      this.residente_nds = '';
      this.residente_dependiente_de = '';
      this.accion_switch = false;
      this.residente_accion_number = '';
      this.direccion_residente = '';
      this.codigo_postal = '';
      this.estado_civil = '';
      this.sexo = '';
      this.fecha_nacimiento = '';
      this.fecha_ingreso = '';
      this.escuela_residente = '';
      this.nombre_emergencia = '';
      this.email_emergencia = '';
      this.telefono_emergencia = '';
      this.interes_golf = false;
      this.interes_tenis = false;
      this.interes_natacion = false;
      this.interes_gym = false;
      this.interes_ludoteca = false;
      this.interes_ayb = false;
      this.interes_torneos = false;
      this.interes_eventos = false;
      this.interes_comunicados = false;
      this.medio_grupo_whatsapp = false;
      this.medio_chat_privado = false;
      this.medio_email = false;
      this.medio_telefono = false;
      this.medio_app = false;
      this.fotos = [];
      this.firmas = [];
      this.fingerprint_image = '';
      this.fingerprint_template = '';
      // document.getElementById('Tb_DisplayLog').value = '';
      // document.getElementById('Fpimg').src = this.baseImg;
      // InfoDelAll(); /* biomini */
      // UnInit(); /* biomini */
      this.$store.commit('capturaResidentes/clearAlertDialog');
      this.$store.commit('capturaResidentes/resetResidenteProcessing');
    },
    close_info_dialog() {
      this.infodialog = false;
    },
    clear_null(value) {
      let tmp = null;
      if (typeof value === 'string') {
        tmp = value.trim();
      } else if (value === null || typeof value === 'undefined') {
        tmp = '';
      } else {
        tmp = value;
      }
      return tmp;
    },
    send_form() {
      if (this.processing === true) {
        return;
      }
      if (this.$refs.form.validate()) {
        this.$store.commit('capturaResidentes/startedResidenteProcessing');
        const formdata = new FormData();
        formdata.set('nombres', this.clear_null(this.nombres_residente));
        formdata.set('apellido_paterno', this.clear_null(this.apellido_paterno_residente));
        formdata.set('apellido_materno', this.clear_null(this.apellido_materno_residente));
        formdata.set('emails', JSON.stringify(this.emails));
        formdata.set('contactos_emergencia', JSON.stringify(this.contactos_emergencia));
        formdata.set('status', this.clear_null(this.status_residente));
        formdata.set('telefonos', JSON.stringify(this.telefonos));
        formdata.set('viviendas', JSON.stringify(this.viviendasAsociadas));
        formdata.set('notas', this.clear_null(this.notas_residente));
        formdata.set('ine', this.clear_null(this.ine_residente));
        formdata.set('curp', this.clear_null(this.curp_residente));
        formdata.set('nds', this.clear_null(this.residente_nds));
        formdata.set('dependiente_de', this.clear_null(this.residente_dependiente_de));
        formdata.set('tiene_accion', this.clear_null(this.accion_switch));
        formdata.set('numero_accion', this.clear_null(this.residente_accion_number));
        formdata.set('direccion_residente', this.clear_null(this.direccion_residente));
        formdata.set('cp', this.clear_null(this.codigo_postal));
        formdata.set('estado_civil', this.clear_null(this.estado_civil));
        formdata.set('sexo', this.clear_null(this.sexo));
        formdata.set('fecha_nacimiento', this.clear_null(this.fecha_nacimiento));
        formdata.set('fecha_ingreso', this.clear_null(this.fecha_ingreso));
        formdata.set('escuela', this.clear_null(this.escuela_residente));
        formdata.set('nombre_emergencia', this.clear_null(this.nombre_emergencia));
        formdata.set('email_emergencia', this.clear_null(this.email_emergencia));
        formdata.set('telefono_emergencia', this.clear_null(this.telefono_emergencia));
        formdata.set('interes_golf', this.clear_null(this.interes_golf));
        formdata.set('interes_tenis', this.clear_null(this.interes_tenis));
        formdata.set('interes_natacion', this.clear_null(this.interes_natacion));
        formdata.set('interes_gym', this.clear_null(this.interes_gym));
        formdata.set('interes_ludoteca', this.clear_null(this.interes_ludoteca));
        formdata.set('interes_ayb', this.clear_null(this.interes_ayb));
        formdata.set('interes_torneos', this.clear_null(this.interes_torneos));
        formdata.set('interes_eventos', this.clear_null(this.interes_eventos));
        formdata.set('interes_comunicados', this.clear_null(this.interes_comunicados));
        formdata.set('medio_gpo_whatsapp', this.clear_null(this.medio_grupo_whatsapp));
        formdata.set('medio_chat_privado', this.clear_null(this.medio_chat_privado));
        formdata.set('medio_email', this.clear_null(this.medio_email));
        formdata.set('medio_telefono', this.clear_null(this.medio_telefono));
        formdata.set('medio_app', this.clear_null(this.medio_app));
        if (this.fotos.length !== 0) {
          formdata.set('foto', this.fotos[this.fotos.length - 1]);
        }
        if (this.firmas.length !== 0) {
          formdata.set('firma', this.firmas[this.firmas.length - 1]);
        }
        if (this.fingerPrint.fingerprint_image.length !== 0) {
          formdata.set('huella_imagen', this.fingerPrint.fingerprint_image);
        }
        if (this.fingerPrint.fingerprint_template.length !== 0) {
          formdata.set('huella_template', this.fingerPrint.fingerprint_template);
        }
        if (this.editing) {
          formdata.set('residente_id', this.resident_info.residente_id);
        }
        this.$store.commit('capturaResidentes/resetResidenteSubmit');
        this.$store.dispatch('capturaResidentes/sendResident', formdata).then(() => {
          this.getDataFromApi()
            .then((data) => {
              this.residentes = data.residentes;
              this.totalItems = data.total;
            });
        });
      }
    },
    append_phone() {
      const temp = {
        id: null,
        telefono: null,
        tipo: null,
        nombre: null,
        id_residente: null,
      };
      this.telefonos.push(temp);
    },
    append_email() {
      const temp = {
        id: null,
        email: null,
        tipo: null,
        id_residente: null,
      };
      this.emails.push(temp);
    },
    delete_email(index) {
      delete this.emails.splice(index, 1);
    },
    delete_vivienda(index) {
      delete this.viviendasAsociadas.splice(index, 1);
    },
    delete_phone(index) {
      delete this.telefonos.splice(index, 1);
    },
    cancelAutoUpdate() {
      clearInterval(this.timer);
    },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    openDialog() {
      this.dialog = true;
    },
    append_contacto_emergencia() {
      const temp = {
        id: null,
        nombre_emergencia: null,
        email_emergencia: null,
        telefono_emergencia: null,
        id_residente: null,
      };
      this.contactos_emergencia.push(temp);
    },
    delete_contacto_emergencia(index) {
      delete this.contactos_emergencia.splice(index, 1);
    },
    send_application_form() {
      if (this.$refs.applicationForm.validate()) {
        const formdata = {
          residente_id: this.resident_info.residente_id,
          fullname: this.resident_info.fullname,
          usuario: this.usuario,
          password: this.password,
          send_email: this.send_email,
        };
        this.$store.dispatch('capturaResidentes/sendResidentApplication', formdata).then(() => {
          this.getDataFromApi().then((data) => {
            this.residentes = data.residentes;
            this.totalItems = data.total;
          });
        });
      }
    },
    send_edit_application_form() {
      if (this.$refs.editApplicationForm.validate()) {
        const formdata = {
          residente_id: this.resident_info.residente_id,
          fullname: this.resident_info.fullname,
          usuario: this.resident_info.usuario,
          password: this.password,
          send_email: this.send_email,
        };
        this.$store.dispatch('capturaResidentes/sendPwdResidentApplication', formdata).then(() => {
          this.getDataFromApi().then((data) => {
            this.residentes = data.residentes;
            this.totalItems = data.total;
          });
        });
      }
    },
    send_session_application_form() {
      this.confirm_session_dialog = false;
      const formdata = { residente_id: this.resident_info.residente_id };
      this.$store.dispatch('capturaResidentes/closeSessionResidentApplication', formdata)
        .then(() => {
          this.getDataFromApi().then((data) => {
            this.residentes = data.residentes;
            this.totalItems = data.total;
          });
        });
    },
    show_delete_resident_dialog(resident) {
      this.$store.dispatch('capturaResidentes/fetchResidentInfo', resident);
      this.confirm_deleted_dialog = true;
    },
    delete_resident_confirm() {
      this.confirm_deleted_dialog = false;
      this.$store.dispatch('capturaResidentes/deleteResident', this.resident_info.residente_id).then(() => {
        this.getDataFromApi().then((data) => {
          this.residentes = data.residentes;
          this.totalItems = data.total;
        });
      });
    },
    delete_resident(resident) {
      this.$store.dispatch('capturaResidentes/deleteResident', resident).then(() => {
        this.getDataFromApi().then((data) => {
          this.residentes = data.residentes;
          this.totalItems = data.total;
        });
      });
    },
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    },
    switchVisibilityConfirm() {
      this.passwordConfirmFieldType = this.passwordConfirmFieldType === 'password' ? 'text' : 'password';
    },
    generatePassword(size = 8, characters = 'a-z,A-Z,0-9,#') {
      const charactersArray = characters.split(',');
      let CharacterSet = '^';
      let CharacterSetOnes = '[';
      let password = '';
      if (charactersArray.indexOf('a-z') >= 0) {
        CharacterSet += '[a-z]{1}';
        CharacterSetOnes += 'a-z';
        size -= 1;
      }
      if (charactersArray.indexOf('A-Z') >= 0) {
        CharacterSet += '[A-Z]{1}';
        CharacterSetOnes += 'A-Z';
        size -= 1;
      }
      if (charactersArray.indexOf('0-9') >= 0) {
        CharacterSet += '[0-9]{1}';
        CharacterSetOnes += '0-9';
        size -= 1;
      }
      if (charactersArray.indexOf('#') >= 0) {
        const setchars = '¡+,.-!"$%&/=?¿^*;:_|@#<>~\'\\\\';
        CharacterSet += `([${setchars}]{1})`;
        CharacterSetOnes += setchars;
        size -= 1;
      }
      CharacterSetOnes += ']';
      CharacterSet += CharacterSetOnes;
      CharacterSet += `{${size}}`;
      CharacterSet += '$';
      let temppassword = new RandExp(CharacterSet).gen();
      temppassword = temppassword.split('');
      while (temppassword.length > 0) {
        password += temppassword.splice(temppassword.length * Math.random() << 0, 1);
      }
      this.password = password;
      this.rePassword = password;
    },
    decode_base64(value) {
      let encoded = '';
      let extension = '';
      if (value !== null) {
        encoded = value;
        const check = encoded.charAt(0);
        if (check === '/') {
          extension = 'jpg';
        } else if (check === '/') {
          extension = 'png';
        } else extension = 'tiff';
      } else {
        extension = 'png';
        encoded = 'R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
      }
      return `data:image/${extension};base64,${encoded}`;
    },
  },
  created() {
    /* if (!(this.$store.getters['capturaResidentes/residentes_list'].length > 0)) {
      this.fetchResidentsList();
    } else {
      this.$store.commit('capturaResidentes/fetchedResidentes');
    } */
    this.user_login_role = getJWTData().user_claims.role;
    if (['jefe_monitoristas', 'monitoristas', 'censo', 'admin', 'admin_eko', 'atencion_residentes', 'censo_residentes', 'avisos'].includes(this.user_login_role)) {
      if (['censo', 'censo_residentes', 'admin', 'admin_eko'].includes(this.user_login_role)) {
        this.view_btn = true;
        this.edit_btn = true;
        this.app_btn = true;
        this.delete_btn = true;
        this.add_btn = true;
      } else if (['jefe_monitoristas', 'monitoristas', 'atencion_residentes', 'avisos'].includes(this.user_login_role)) {
        this.view_btn = true;
      }
    }
  },
  beforeDestroy() {
    this.cancelSearchTimer();
  },
  mounted() {
    // console.log(this.$vuetify.breakpoint);
  },
};
</script>
